module.exports = __webpack_public_path__ + "media/new_game.4f52fe9d.mp3";